import { PermissionedRoutes, ValidatedRoutes } from "@components/PermissionedRoutes";
import { INSTITUTION_SETTINGS_ROUTES } from "@pages/institution_settings/routes";
import { RouteObject } from "react-router-dom";
import { APPLICATION_CONFIGURATION_ROUTES } from "./applications/routes";
import { MESSAGE_CONFIGURATION_ROUTES } from "./messages/routes";
import { isSyncSettingsEnabled } from "./settings_sync/isSyncSettingsEnabled";
import jsonFromDocument from "cerulean/src/JsonFromDocument";

export const CONFIGURATION_ROUTES: RouteObject[] = [
  {
    path: "institution_settings",
    element: (
      <ValidatedRoutes
        validate={({ permissions, features, roles }) => {
          const isDemo = Boolean(jsonFromDocument("institution_is_demo", "false"));
          const isLocal = Boolean(jsonFromDocument("institution_is_local", "false"));
          return (
            (isLocal ||
              (roles.narmi && !isDemo) ||
              features.includes("institution_settings_redesign")) &&
            (permissions.includes("backoffice.change_settings") ||
              permissions.includes("backoffice.view_settings"))
          );
        }}
      />
    ),
    children: INSTITUTION_SETTINGS_ROUTES,
  },
  {
    path: "messages",
    children: MESSAGE_CONFIGURATION_ROUTES,
  },
  {
    path: "applications",
    children: APPLICATION_CONFIGURATION_ROUTES,
  },
  {
    path: "sync_settings",
    element: (
      <ValidatedRoutes
        validate={({ roles, features }) =>
          isSyncSettingsEnabled({
            roles,
            features,
            isLocal: Boolean(jsonFromDocument("institution_is_local", "false")),
            isDemo: Boolean(jsonFromDocument("institution_is_demo", "false")),
          })
        }
      />
    ),
    children: [
      {
        index: true,
        async lazy() {
          const { default: SettingsSyncPage } = await import("./settings_sync/SettingsSyncPage");
          return { element: <SettingsSyncPage /> };
        },
      },
    ],
  },
  {
    path: "sftp_wizard",
    element: (
      <PermissionedRoutes
        requiredPermissions={["backoffice.change_settings"]}
        requiredRoles={["narmi"]}
      />
    ),
    children: [
      {
        index: true,
        async lazy() {
          const { SftpWizard } = await import("./sftp_wizard/SftpWizard");
          return { element: <SftpWizard /> };
        },
      },
    ],
  },
];
